import { api } from '@/services/api'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

interface College {
  id: string;
  name: string;
  code: string;
  address: string;
  phone: string;
  email: string;
  establishedYear: number;
  isActive: boolean;
}

interface PaginationInfo {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

interface CollegeState {
  colleges: College[];
  currentCollege: College | null;
  pagination: PaginationInfo;
  isLoading: boolean;
  error: string | null;
}

interface FetchCollegesParams {
  page?: number;
  limit?: number;
  search?: string;
}

const initialState: CollegeState = {
  colleges: [],
  currentCollege: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
  isLoading: false,
  error: null,
};

export const fetchColleges = createAsyncThunk(
  "college/fetchColleges",
  async (params: FetchCollegesParams = {}, { rejectWithValue }) => {
    try {

      console.log('🔍 Fetching colleges with params:', params)
      const queryParams = new URLSearchParams()
      if (params.page) queryParams.append('page', params.page.toString())
      if (params.limit) queryParams.append('limit', params.limit.toString())
      if (params.search) queryParams.append('search', params.search)
      
      const token = localStorage.getItem('token'); const response = await api.get(`/colleges?${queryParams.toString()}`, { headers: { Authorization: `Bearer ${token}` } })
      console.log('✅ Colleges API response:', response.data)
      return response.data // Backend returns { success, message, data, meta }

    } catch (error: any) {
      console.error("❌ Colleges API error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch colleges"
      );
    }
  }
);

const collegeSlice = createSlice({
  name: "college",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchColleges.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchColleges.fulfilled, (state, action) => {
        state.isLoading = false;
        state.colleges = action.payload.data;
        state.pagination = {
          page: action.payload.meta.page,
          limit: action.payload.meta.limit,
          total: action.payload.meta.total,
          totalPages: action.payload.meta.totalPages,
        };
      })
      .addCase(fetchColleges.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = collegeSlice.actions;
export default collegeSlice.reducer;
